document.addEventListener('DOMContentLoaded', function()
{
    document.querySelectorAll('.js-view-video').forEach(videoContainer =>
    {
        const video = videoContainer.querySelector('video');
        const videoPosterOverlay = videoContainer.querySelector('.js-view-video__poster-overlay');
        const playpauseButton = videoContainer.querySelector('.js-playpause');

        const pauseVideo = () =>
        {
            if (video.paused)
            {
                return;
            }
            video.pause();
        };

        const isInViewport = (e) =>
        {
            const rect = e.getBoundingClientRect();

            return (
                rect.top >= -150
				&& rect.left >= 0
				&& rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
				&& rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        };

        playpauseButton.addEventListener('click', () =>
        {
            videoPosterOverlay.style.opacity = '100%';
            video.setAttribute('controls', 'controls');
            video.play();
            playpauseButton.classList.add('hidden');
        });

        document.addEventListener('scroll', () =>
        {
            if (!isInViewport(video))
            {
                pauseVideo();
            }
        });
    });
});
